// 旧 App（app/、/api/...）につなぐ。返す形が共通画面の基準。
import {
  getUserEpisode,
  listQuestGroup,
  listTickets,
  createStripeTicketCheckoutSession,
  createPayPayTicketQrCode,
  getUnconfirmedPayPayPayment,
  getPayPayPaymentStatus,
  getUserEmail,
  updateUserEmail,
  getGuidelinesAgreementStatus,
  postGuidelinesAgreement,
  scheduleModeSwitch,
  unscheduleModeSwitch,
} from "utils/api";

export const appBackend = {
  kind: "app",

  // 未購入なら null
  getEpisode: async (soulId) => {
    const episode = await getUserEpisode(soulId);
    return episode && { ...episode, can_extend: false };
  },

  listQuestGroups: (soulId) => listQuestGroup(soulId),

  // App は続けて買うチケットの key に "repurchase" を含める
  listTickets: async (soulId) => {
    const tickets = await listTickets(soulId);
    return tickets.map((ticket) => ({
      ...ticket,
      is_continuation: ticket.ticket_key.includes("repurchase"),
    }));
  },

  purchaseWithStripe: (soulId, ticket) =>
    createStripeTicketCheckoutSession(soulId, ticket.episode_id, ticket.ticket_key),

  purchaseWithPaypay: async (soulId, ticket) => {
    const { data } = await createPayPayTicketQrCode(
      soulId,
      ticket.episode_id,
      ticket.ticket_key
    );
    return { url: data.url };
  },

  // 未確定の PayPay 支払いが無ければ null
  getUnconfirmedPaypay: async (soulId) => {
    const { merchant_payment_id: merchantPaymentId } =
      await getUnconfirmedPayPayPayment(soulId);
    return merchantPaymentId ? { merchant_payment_id: merchantPaymentId } : null;
  },

  getPaypayStatus: (merchantPaymentId, options) =>
    getPayPayPaymentStatus(merchantPaymentId, options),

  getEmail: () => getUserEmail(),
  updateEmail: (emailAddress, disableMailDelivery) =>
    updateUserEmail(emailAddress, disableMailDelivery),

  // true / false。チケットが無いうちは null
  getGuidelinesAgreement: (soulId) => getGuidelinesAgreementStatus(soulId),
  agreeGuidelines: (soulId) => postGuidelinesAgreement(soulId),

  scheduleModeSwitch: (soulId) => scheduleModeSwitch(soulId),
  unscheduleModeSwitch: (soulId) => unscheduleModeSwitch(soulId),
};
